// SET_WORKS
export const setWroks = (works) => ({
  type: 'SET_WORKS',
  works
});



// WEBPACK FOOTER //
// ./src/actions/works.js